export interface NativeInformation {
	isApp: boolean;
	os: NativeOperationSystem;
	versions: {
		android: string;
		ios: string;
	};
}

export enum NativeOperationSystem {
	ANDROID = 'android',
	PHONE = 'Phone',
	IOS = 'IOS',
	WEB = '',
	UNKNOWN = 'Unknown',
}
